module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ca-Db-Ec-Gb.d2a40560.png";